// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1YBCs","footer":"ModalError_footer__3PUCZ"};